import React, { JSX, useState } from "react";
import Link from "next/link";
import { colors } from "constants/colors";

import st from "./homeHero.module.scss";

export interface HomeHeroContent {
  desktopImg: string;
  mobileImg: string;
  videoUrl?: string;
  mobileVideoUrl?: string;
  href: string;
  alt: string;
}

// The homepage campaign hero — live's muted looping inline film with a themed
// speaker toggle, or a static campaign image when no film is configured.
export function HomeHero({ data }: { data: HomeHeroContent }): JSX.Element {
  const [muted, setMuted] = useState(true);
  return (
    <Link href={data.href || "/"} className={st.hero} aria-label={data.alt}>
      {data.videoUrl ? (
        <>
          <video className={st.heroImg} autoPlay loop muted={muted} playsInline>
            {data.mobileVideoUrl && (
              <source media="(max-width: 767px)" src={data.mobileVideoUrl} />
            )}
            <source src={data.videoUrl} />
          </video>
          <button
            type="button"
            className={st.heroMute}
            aria-label={muted ? "unmute video" : "mute video"}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setMuted((m) => !m);
            }}
          >
            <svg viewBox="0 0 50 50" fill="none" aria-hidden="true">
              <circle cx="26" cy="26" r="24" fill={colors.purple} />
              <circle
                cx="24"
                cy="24"
                r="23"
                fill={colors.cyan}
                stroke={colors.purple}
                strokeWidth="2"
              />
              <path
                d="M14 20v8h5l6 5V15l-6 5h-5Zm17.5-1.5c1.6 1.4 2.5 3.3 2.5 5.5s-.9 4.1-2.5 5.5"
                stroke={colors.purple}
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
              {muted && (
                <path
                  d="M13 13l22 22"
                  stroke={colors.purple}
                  strokeWidth="2.4"
                  strokeLinecap="round"
                />
              )}
            </svg>
          </button>
        </>
      ) : (
        <picture>
          <source media="(max-width: 767px)" srcSet={data.mobileImg} />
          <img className={st.heroImg} src={data.desktopImg} alt={data.alt} />
        </picture>
      )}
    </Link>
  );
}
